import "../styles/components/Loading.css";

const Loading = () => {
    return (<div id='loading' />);
};

export default Loading;